import * as StyleSheet from './utils/StyleSheet';

import Breakpoints from './utils/Breakpoints';

import palettes from './themes/palettes';

export const IconStyles = theme =>
  StyleSheet.create({
    'Menu Icon': {
      style: {},
      props: { color: palettes.Brand.Black, size: 20 },
    },
  });

export const TextStyles = theme =>
  StyleSheet.create({
    'Chart Text': {
      style: {
        color: [
          { minWidth: Breakpoints.Mobile, value: theme.colors.text.strong },
          { minWidth: Breakpoints.Laptop, value: palettes.Brand.Black },
        ],
        fontFamily: { minWidth: Breakpoints.Laptop, value: 'OpenSans_700Bold' },
        fontSize: { minWidth: Breakpoints.Laptop, value: 10 },
        textAlign: { minWidth: Breakpoints.Laptop, value: 'center' },
      },
      props: {},
    },
    'Chart Text White': {
      style: {
        color: [
          { minWidth: Breakpoints.Laptop, value: '"rgb(255, 255, 255)"' },
          { minWidth: Breakpoints.Mobile, value: theme.colors.text.strong },
        ],
        fontFamily: {
          minWidth: Breakpoints.Laptop,
          value: 'OpenSans_600SemiBold',
        },
        fontSize: { minWidth: Breakpoints.Laptop, value: 10 },
      },
      props: {},
    },
    'Get Started Text': {
      style: {
        color: theme.colors.text.strong,
        fontFamily: {
          minWidth: Breakpoints.Laptop,
          value: 'OpenSans_600SemiBold',
        },
        fontSize: { minWidth: Breakpoints.Laptop, value: 14 },
      },
      props: {},
    },
    Header: {
      style: {
        color: [
          { minWidth: Breakpoints.Mobile, value: theme.colors.text.strong },
          { minWidth: Breakpoints.Laptop, value: palettes.Brand.White },
        ],
        fontFamily: { minWidth: Breakpoints.Laptop, value: 'Inter_400Regular' },
        fontSize: { minWidth: Breakpoints.Laptop, value: 24 },
      },
      props: {},
    },
    'Menu Text': {
      style: {
        color: { minWidth: Breakpoints.Laptop, value: palettes.Brand.Black },
        fontFamily: { minWidth: Breakpoints.Laptop, value: 'OpenSans_700Bold' },
        fontSize: { minWidth: Breakpoints.Laptop, value: 12 },
      },
      props: {},
    },
    'Script Text': {
      style: {
        color: [
          { minWidth: Breakpoints.Laptop, value: palettes.Brand.White },
          { minWidth: Breakpoints.Mobile, value: theme.colors.text.strong },
        ],
        fontFamily: {
          minWidth: Breakpoints.Laptop,
          value: 'SeaweedScript_400Regular',
        },
        fontSize: { minWidth: Breakpoints.Laptop, value: 20 },
      },
      props: {},
    },
    Text: { style: { color: theme.colors.text.strong }, props: {} },
    Widgets: {
      style: {
        color: [
          { minWidth: Breakpoints.Laptop, value: palettes.Brand.Black },
          { minWidth: Breakpoints.Desktop, value: palettes.Brand.Black },
        ],
        fontFamily: [
          { minWidth: Breakpoints.Desktop, value: 'OpenSans_400Regular' },
          { minWidth: Breakpoints.Laptop, value: 'OpenSans_500Medium' },
        ],
        fontSize: [
          { minWidth: Breakpoints.Desktop, value: 20 },
          { minWidth: Breakpoints.Laptop, value: 18 },
          { minWidth: Breakpoints.BigScreen, value: 26 },
        ],
        marginLeft: { minWidth: Breakpoints.Desktop, value: 0 },
        textAlign: [
          { minWidth: Breakpoints.Desktop, value: 'center' },
          { minWidth: Breakpoints.Laptop, value: 'center' },
        ],
      },
      props: {},
    },
  });

export const TextInputStyles = theme =>
  StyleSheet.create({
    'Login Flow': {
      style: {
        backgroundColor: [
          { minWidth: Breakpoints.Laptop, value: '"rgb(255, 255, 255)"' },
          { minWidth: Breakpoints.Desktop, value: palettes.Brand.White },
          { minWidth: Breakpoints.Mobile, value: palettes.Brand.White },
        ],
        borderBottomWidth: 1,
        borderLeftWidth: 1,
        borderRadius: 8,
        borderRightWidth: 1,
        borderTopWidth: 1,
        fontFamily: [
          { minWidth: Breakpoints.Laptop, value: 'OpenSans_500Medium' },
          { minWidth: Breakpoints.Mobile, value: 'OpenSans_500Medium' },
        ],
        fontSize: [
          { minWidth: Breakpoints.Laptop, value: 16 },
          { minWidth: Breakpoints.Mobile, value: 16 },
        ],
        paddingBottom: 16,
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 16,
      },
      props: {},
    },
    'Mobile Login Input': {
      style: {
        backgroundColor: [
          { minWidth: Breakpoints.Laptop, value: '"rgb(255, 255, 255)"' },
          { minWidth: Breakpoints.Mobile, value: palettes.Brand.White },
        ],
        borderBottomWidth: 1,
        borderLeftWidth: 1,
        borderRadius: 8,
        borderRightWidth: 1,
        borderTopWidth: 1,
        color: palettes.Brand.Black,
        fontFamily: [
          { minWidth: Breakpoints.Laptop, value: 'OpenSans_500Medium' },
          { minWidth: Breakpoints.Mobile, value: 'OpenSans_500Medium' },
        ],
        fontSize: [
          { minWidth: Breakpoints.Laptop, value: 16 },
          { minWidth: Breakpoints.Mobile, value: 16 },
        ],
        paddingBottom: 12,
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 12,
      },
      props: { placeholderTextColor: palettes.Brand.Black },
    },
    'Mobile Password': {
      style: {
        backgroundColor: [
          { minWidth: Breakpoints.Laptop, value: '"rgb(255, 255, 255)"' },
          { minWidth: Breakpoints.Mobile, value: palettes.Brand.White },
        ],
        borderBottomWidth: 1,
        borderLeftWidth: 1,
        borderRadius: 8,
        borderRightWidth: 1,
        borderTopWidth: 1,
        color: palettes.Brand.Black,
        fontFamily: [
          { minWidth: Breakpoints.Laptop, value: 'OpenSans_500Medium' },
          { minWidth: Breakpoints.Mobile, value: 'OpenSans_500Medium' },
        ],
        fontSize: [
          { minWidth: Breakpoints.Laptop, value: 16 },
          { minWidth: Breakpoints.Mobile, value: 16 },
        ],
        paddingBottom: [
          { minWidth: Breakpoints.Mobile, value: 12 },
          { minWidth: Breakpoints.Desktop, value: 8 },
        ],
        paddingLeft: 8,
        paddingRight: [
          { minWidth: Breakpoints.Mobile, value: 32 },
          { minWidth: Breakpoints.Laptop, value: 32 },
        ],
        paddingTop: [
          { minWidth: Breakpoints.Mobile, value: 12 },
          { minWidth: Breakpoints.Desktop, value: 8 },
        ],
      },
      props: { placeholderTextColor: palettes.Brand.Black },
    },
    'Table Text Input': {
      style: {
        backgroundColor: {
          minWidth: Breakpoints.Laptop,
          value: 'rgba(0, 0, 0, 0)',
        },
        borderBottomWidth: [
          { minWidth: Breakpoints.Laptop, value: 0 },
          { minWidth: Breakpoints.Mobile, value: 1 },
        ],
        borderColor: theme.colors.border.brand,
        borderLeftWidth: [
          { minWidth: Breakpoints.Laptop, value: 0 },
          { minWidth: Breakpoints.Mobile, value: 1 },
        ],
        borderRadius: [
          { minWidth: Breakpoints.Laptop, value: 0 },
          { minWidth: Breakpoints.Mobile, value: 8 },
        ],
        borderRightWidth: [
          { minWidth: Breakpoints.Mobile, value: 1 },
          { minWidth: Breakpoints.Laptop, value: 0 },
        ],
        borderTopWidth: [
          { minWidth: Breakpoints.Mobile, value: 1 },
          { minWidth: Breakpoints.Laptop, value: 0 },
        ],
        fontFamily: {
          minWidth: Breakpoints.Laptop,
          value: 'OpenSans_500Medium',
        },
        fontSize: { minWidth: Breakpoints.Laptop, value: 10 },
        paddingBottom: [
          { minWidth: Breakpoints.Mobile, value: 8 },
          { minWidth: Breakpoints.Laptop, value: 0 },
        ],
        paddingLeft: [
          { minWidth: Breakpoints.Mobile, value: 8 },
          { minWidth: Breakpoints.Laptop, value: 0 },
        ],
        paddingRight: 8,
        paddingTop: [
          { minWidth: Breakpoints.Mobile, value: 8 },
          { minWidth: Breakpoints.Laptop, value: 0 },
        ],
        textAlign: { minWidth: Breakpoints.Laptop, value: 'right' },
        width: { minWidth: Breakpoints.Laptop, value: '100%' },
      },
      props: {},
    },
    'Text Input': {
      style: {
        backgroundColor: {
          minWidth: Breakpoints.Laptop,
          value: '"rgb(255, 255, 255)"',
        },
        borderBottomWidth: 1,
        borderLeftWidth: 1,
        borderRadius: 8,
        borderRightWidth: 1,
        borderTopWidth: 1,
        fontFamily: {
          minWidth: Breakpoints.Laptop,
          value: 'OpenSans_500Medium',
        },
        fontSize: { minWidth: Breakpoints.Laptop, value: 16 },
        paddingBottom: 8,
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 8,
      },
      props: {},
    },
  });

export const LinkStyles = theme =>
  StyleSheet.create({
    'Cancel Link': {
      style: {
        color: [
          {
            minWidth: Breakpoints.Mobile,
            value: theme.colors.branding.primary,
          },
          { minWidth: Breakpoints.Laptop, value: palettes.Brand['App Green'] },
        ],
        fontFamily: {
          minWidth: Breakpoints.Laptop,
          value: 'Inter_600SemiBold',
        },
        fontSize: { minWidth: Breakpoints.Laptop, value: 16 },
        textTransform: { minWidth: Breakpoints.Laptop, value: 'uppercase' },
      },
      props: {},
    },
    Link: { style: { color: theme.colors.branding.primary }, props: {} },
    'New Link': {
      style: {
        color: [
          {
            minWidth: Breakpoints.Mobile,
            value: theme.colors.branding.primary,
          },
          { minWidth: Breakpoints.Laptop, value: palettes.Brand['App Green'] },
        ],
        fontFamily: {
          minWidth: Breakpoints.Laptop,
          value: 'Inter_600SemiBold',
        },
        fontSize: [
          { minWidth: Breakpoints.Desktop, value: 16 },
          { minWidth: Breakpoints.Laptop, value: 18 },
        ],
        marginTop: { minWidth: Breakpoints.Laptop, value: 40 },
        textTransform: { minWidth: Breakpoints.Laptop, value: 'uppercase' },
      },
      props: {},
    },
  });

export const ImageStyles = theme =>
  StyleSheet.create({
    Image: { style: { height: 100, width: 100 }, props: {} },
  });

export const ViewStyles = theme =>
  StyleSheet.create({
    'Get Started View': {
      style: {
        borderRadius: { minWidth: Breakpoints.Laptop, value: 8 },
        padding: { minWidth: Breakpoints.Laptop, value: 12 },
      },
      props: {},
    },
  });

export const LinearGradientStyles = theme =>
  StyleSheet.create({
    'Blue Linear': {
      style: {
        alignItems: { minWidth: Breakpoints.Laptop, value: 'center' },
        flex: 1,
        flexDirection: { minWidth: Breakpoints.Laptop, value: 'row' },
        gap: { minWidth: Breakpoints.Laptop, value: 4 },
        justifyContent: { minWidth: Breakpoints.Laptop, value: 'center' },
        paddingBottom: { minWidth: Breakpoints.Laptop, value: 4 },
        paddingTop: { minWidth: Breakpoints.Laptop, value: 4 },
      },
      props: {
        color1: palettes.Brand['App Blue Dark'],
        color2: palettes.App['App Blue Light'],
        color3: palettes.Brand['App Blue Dark'],
      },
    },
    'Category Gradient': {
      style: {
        alignItems: { minWidth: Breakpoints.Laptop, value: 'center' },
        borderBottomWidth: { minWidth: Breakpoints.Laptop, value: 1 },
        borderRightWidth: { minWidth: Breakpoints.Laptop, value: 1 },
        flex: 1,
        height: { minWidth: Breakpoints.Laptop, value: 25 },
        justifyContent: { minWidth: Breakpoints.Laptop, value: 'center' },
        maxHeight: { minWidth: Breakpoints.Laptop, value: 25 },
        minHeight: { minWidth: Breakpoints.Laptop, value: 25 },
        minWidth: { minWidth: Breakpoints.Laptop, value: 75 },
        width: { minWidth: Breakpoints.Laptop, value: 75 },
      },
      props: {
        color1: palettes.App['Gray Linear Light'],
        color2: palettes.App['Gray Linear Dark'],
        color3: null,
      },
    },
    'Header Linear Gradient': {
      style: {
        flexDirection: { minWidth: Breakpoints.Laptop, value: 'row' },
        justifyContent: { minWidth: Breakpoints.Laptop, value: 'center' },
        padding: { minWidth: Breakpoints.Laptop, value: 10 },
      },
      props: {
        color1: palettes.Brand['App Blue Dark'],
        color2: palettes.App['App Blue Light'],
      },
    },
    'Inner Gradient': {
      style: {
        alignItems: { minWidth: Breakpoints.Laptop, value: 'center' },
        borderColor: {
          minWidth: Breakpoints.Laptop,
          value: palettes.Brand.Black,
        },
        borderRightWidth: { minWidth: Breakpoints.Laptop, value: 1 },
        borderTopWidth: { minWidth: Breakpoints.Laptop, value: 1 },
        flex: 1,
        flexDirection: { minWidth: Breakpoints.Laptop, value: 'row' },
        height: { minWidth: Breakpoints.Laptop, value: 25 },
        justifyContent: { minWidth: Breakpoints.Laptop, value: 'center' },
        maxHeight: { minWidth: Breakpoints.Laptop, value: 25 },
        maxWidth: { minWidth: Breakpoints.Laptop, value: 75 },
        minHeight: { minWidth: Breakpoints.Laptop, value: 25 },
        minWidth: { minWidth: Breakpoints.Laptop, value: 75 },
        paddingRight: { minWidth: Breakpoints.Laptop, value: 0 },
        width: { minWidth: Breakpoints.Laptop, value: 75 },
      },
      props: {
        color1: 'theme.colors["Inner Gradient"]',
        color2: palettes.App['Gray Linear Dark'],
        color3: 'theme.colors["Inner Gradient"]',
      },
    },
    'Linear Gradient': {
      style: {
        alignItems: { minWidth: Breakpoints.Laptop, value: 'center' },
        borderBottomWidth: { minWidth: Breakpoints.Laptop, value: 1 },
        borderColor: {
          minWidth: Breakpoints.Laptop,
          value: palettes.Brand.Black,
        },
        borderRightWidth: { minWidth: Breakpoints.Laptop, value: 1 },
        flex: 1,
        justifyContent: { minWidth: Breakpoints.Laptop, value: 'center' },
      },
      props: {},
    },
  });

export const ButtonStyles = theme =>
  StyleSheet.create({
    Button: {
      style: {
        backgroundColor: theme.colors.branding.primary,
        borderRadius: 8,
        fontFamily: 'System',
        fontWeight: '700',
        textAlign: 'center',
      },
      props: {},
    },
    'Mobile Button': {
      style: {
        backgroundColor: [
          {
            minWidth: Breakpoints.Mobile,
            value: palettes.Brand['App Blue Dark'],
          },
          {
            minWidth: Breakpoints.Laptop,
            value: palettes.Brand['App Blue Dark'],
          },
        ],
        borderRadius: 8,
        color: [
          { minWidth: Breakpoints.Laptop, value: palettes.Brand.White },
          { minWidth: Breakpoints.Mobile, value: palettes.Brand.White },
        ],
        fontFamily: [
          { minWidth: Breakpoints.Mobile, value: 'OpenSans_400Regular' },
          { minWidth: Breakpoints.Laptop, value: 'OpenSans_300Light' },
        ],
        fontSize: [
          { minWidth: Breakpoints.Laptop, value: 18 },
          { minWidth: Breakpoints.Mobile, value: 18 },
        ],
        letterSpacing: [
          { minWidth: Breakpoints.Laptop, value: 1 },
          { minWidth: Breakpoints.Mobile, value: 0.2 },
        ],
        textAlign: 'center',
        width: [
          { minWidth: Breakpoints.Laptop, value: '15%' },
          { minWidth: Breakpoints.Desktop, value: '10%' },
          { minWidth: Breakpoints.BigScreen, value: '8%' },
          { minWidth: Breakpoints.Tablet, value: '25%' },
          { minWidth: Breakpoints.Mobile, value: '30%' },
        ],
      },
      props: {},
    },
    'New Submit Button': {
      style: {
        backgroundColor: [
          {
            minWidth: Breakpoints.Mobile,
            value: theme.colors.branding.primary,
          },
          { minWidth: Breakpoints.Laptop, value: palettes.Brand['App Green'] },
        ],
        borderRadius: 8,
        color: {
          minWidth: Breakpoints.Laptop,
          value: theme.colors.background.brand,
        },
        fontFamily: [
          { minWidth: Breakpoints.Mobile, value: 'System' },
          { minWidth: Breakpoints.Laptop, value: 'OpenSans_400Regular' },
        ],
        fontSize: { minWidth: Breakpoints.Laptop, value: 18 },
        fontWeight: { minWidth: Breakpoints.Mobile, value: '700' },
        textAlign: 'center',
        width: { minWidth: Breakpoints.Laptop, value: '15%' },
      },
      props: {},
    },
    'Submit Button': {
      style: {
        backgroundColor: [
          {
            minWidth: Breakpoints.Mobile,
            value: theme.colors.branding.primary,
          },
          { minWidth: Breakpoints.Laptop, value: palettes.Brand['App Green'] },
        ],
        borderRadius: 8,
        fontFamily: 'System',
        fontWeight: '700',
        textAlign: 'center',
        width: { minWidth: Breakpoints.Laptop, value: '25%' },
      },
      props: {},
    },
  });

export const NumberInputStyles = theme =>
  StyleSheet.create({
    'Number Input': {
      style: {
        borderBottomWidth: 1,
        borderLeftWidth: 1,
        borderRadius: 8,
        borderRightWidth: 1,
        borderTopWidth: 1,
        paddingBottom: 8,
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 8,
      },
      props: {},
    },
    'Table Number Input': {
      style: {
        borderBottomWidth: [
          { minWidth: Breakpoints.Mobile, value: 1 },
          { minWidth: Breakpoints.Laptop, value: 0 },
        ],
        borderColor: theme.colors.border.brand,
        borderLeftWidth: [
          { minWidth: Breakpoints.Mobile, value: 1 },
          { minWidth: Breakpoints.Laptop, value: 0 },
        ],
        borderRadius: [
          { minWidth: Breakpoints.Laptop, value: 0 },
          { minWidth: Breakpoints.Mobile, value: 8 },
        ],
        borderRightWidth: [
          { minWidth: Breakpoints.Laptop, value: 0 },
          { minWidth: Breakpoints.Mobile, value: 1 },
        ],
        borderTopWidth: [
          { minWidth: Breakpoints.Mobile, value: 1 },
          { minWidth: Breakpoints.Laptop, value: 0 },
        ],
        fontFamily: {
          minWidth: Breakpoints.Laptop,
          value: 'OpenSans_600SemiBold',
        },
        fontSize: { minWidth: Breakpoints.Laptop, value: 10 },
        height: { minWidth: Breakpoints.Laptop, value: 25 },
        paddingBottom: 8,
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 8,
        textAlign: { minWidth: Breakpoints.Laptop, value: 'center' },
        width: { minWidth: Breakpoints.Laptop, value: '100%' },
      },
      props: {},
    },
  });

export const FetchStyles = theme =>
  StyleSheet.create({ Fetch: { style: { minHeight: 40 }, props: {} } });

export const SVGStyles = theme =>
  StyleSheet.create({ SVG: { style: { height: 100, width: 100 }, props: {} } });

export const ImageBackgroundStyles = theme =>
  StyleSheet.create({ 'Image Background': { style: { flex: 1 }, props: {} } });

export const CircleStyles = theme =>
  StyleSheet.create({
    Circle: {
      style: {
        alignItems: 'center',
        backgroundColor: theme.colors.branding.primary,
        justifyContent: 'center',
      },
      props: {},
    },
  });

export const DatePickerStyles = theme =>
  StyleSheet.create({
    'Date Picker': {
      style: {
        backgroundColor: {
          minWidth: Breakpoints.Laptop,
          value: 'rgba(0, 0, 0, 0)',
        },
        borderBottomWidth: { minWidth: Breakpoints.Laptop, value: 0 },
        borderLeftWidth: { minWidth: Breakpoints.Laptop, value: 0 },
        borderRightWidth: { minWidth: Breakpoints.Laptop, value: 0 },
        borderTopWidth: { minWidth: Breakpoints.Laptop, value: 0 },
        fontFamily: {
          minWidth: Breakpoints.Laptop,
          value: 'OpenSans_600SemiBold',
        },
        fontSize: { minWidth: Breakpoints.Laptop, value: 10 },
        maxHeight: { minWidth: Breakpoints.Laptop, value: 25 },
        padding: { minWidth: Breakpoints.Laptop, value: 0 },
        paddingBottom: { minWidth: Breakpoints.Laptop, value: 0 },
        paddingLeft: { minWidth: Breakpoints.Laptop, value: 0 },
        paddingRight: { minWidth: Breakpoints.Laptop, value: 0 },
        paddingTop: { minWidth: Breakpoints.Laptop, value: 0 },
        textAlign: { minWidth: Breakpoints.Laptop, value: 'right' },
        width: { minWidth: Breakpoints.Laptop, value: '100%' },
      },
      props: {},
    },
  });

export const BlurViewStyles = theme =>
  StyleSheet.create({
    'Blur View': {
      style: { flexBasis: 0, flexGrow: 1, flexShrink: 1 },
      props: {},
    },
    'Scenario Blur': {
      style: {
        flex: { minWidth: Breakpoints.Laptop, value: 1 },
        flexBasis: 0,
        flexGrow: 1,
        flexShrink: 1,
        marginLeft: [
          { minWidth: Breakpoints.Laptop, value: '20%' },
          { minWidth: Breakpoints.Desktop, value: '15%' },
        ],
      },
      props: { intensity: 15, tint: 'dark' },
    },
  });

export const WebViewStyles = theme =>
  StyleSheet.create({ 'HTML View': { style: { flex: 1 }, props: {} } });

export const ActivityIndicatorStyles = theme =>
  StyleSheet.create({
    'Activity Indicator': { style: { height: 36, width: 36 }, props: {} },
  });

export const SurfaceStyles = theme =>
  StyleSheet.create({ Surface: { style: { minHeight: 40 }, props: {} } });
